<template>
    <BaseView>
        <template #navbar>
            <div class="flex justify-between w-full items-center">
                <RepoNavigation/>
                <SearchBar></SearchBar>
            </div>
        </template>
        <div class="bg-surface-0 dark:bg-surface-900 shadow rounded-border p-4 h-full m-auto overflow-y-auto" :style="maxWidthStyle">
            <router-view />
        </div>
    </BaseView>
</template>
<script setup>
import BaseView from "@/src/views/BaseView.vue";
import RepoNavigation from "@/src/views/repo/RepoNavigation.vue";
import SearchBar from "@/src/views/repo/SearchBar.vue";

import {computed} from "vue";
import {useRouter} from "vue-router";
import {ROUTE_NAMES} from "@/src/router";

const router = useRouter();
const maxWidthStyle = computed(() => {
    if (router.currentRoute.value.name == ROUTE_NAMES.GRAPH) {
        return null
    }
    return {maxWidth: '900px'}
})
</script>
